export default "__VITE_ASSET__4rt8S87y__"